/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// apiUrl: 'http://163.53.85.48:7073/fixed-assets-management-0.0.1-SNAPSHOT', //   ,
export const environment = {
  production: true,

  // apiUrl: 'http://localhost:7077',

// 
  // apiUrl: 'http://localhost:7062',

  ///test server
  //  apiUrl: 'https://api.postprop.in/lhs_fi',

  ///live server

  apiUrl: 'https://api.postprop.in/vserv',
  
  // apiUrl: 'http://103.228.112.178:7070/fixed-assets-management-ERP-0.0.1-SNAPSHOT',

};



